module.exports = __webpack_public_path__ + "static/media/tier-5.09e5646f.jpg";